import React, { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import TopNavContainer from './topNav/TopNavContainer';
import MainNavContainer from './mainNav/MainNavContainer';
import StyledAppBar from './AppBar.styled';
// import data from '../../../json/header.json';
import { getPrepayCarts } from '../../integration/cart.api';
import SkipToMainContent from './SkipToMainContent';
import { getCookie, setCookie } from '../../hooks/useCookie';

const EirHeader = ({ cmsHeaderData }) => {
  const theme = useTheme();
  const graphql = useApolloClient();
  const [cartCount, setCartCount] = useState(0);
  const getPrepayCart = async variables => {
    const cartData = await getPrepayCarts({ graphql, variables });
    console.log(cartData?.numberOfProducts, ' products in prepay cart');
    setCartCount(cartData?.numberOfProducts);
  };
  const getStoreCart = async () => {
    const response = await fetch('/store/api/cart');
    const cartData = await response.json();
    console.log(cartData?.numberOfProducts, ' products in store cart');
    setCartCount(cartData?.numberOfProducts);
  };
  useEffect(() => {
    // if prepay journey
    if (localStorage.getItem('prospectUuid')) {
      setCookie('EIR', 'prepay_prospectUuid', localStorage.getItem('prospectUuid'));
      getPrepayCart({ prospectUuid: getCookie('prepay_prospectUuid') });
    }
    // if store journey
    if (getCookie('eir_current_order')) {
      setCookie('EIR', 'orderId', getCookie('eir_current_order'));
      getStoreCart();
    }
  }, []);

  return (
    <header id='eir-header'>
      <StyledAppBar position='static'>
        <Grid container>
          <Grid item xs={12} sx={{ background: theme.palette.primary.backgroundColor3 }}>
            <SkipToMainContent />
          </Grid>
          <Grid item xs={12} sx={{ background: theme.palette.primary.backgroundColor3 }}>
            <TopNavContainer navCmsHeaderData={cmsHeaderData?.attributes} />
          </Grid>
          <Grid item xs={12}>
            <MainNavContainer
              nav={cmsHeaderData?.attributes?.PrimaryNav}
              leftNav={cmsHeaderData?.attributes?.SecondaryNavLeft}
              rightNav={cmsHeaderData?.attributes?.SecondaryNavRight}
              cartCountNumber={cartCount}
            />
          </Grid>
        </Grid>
      </StyledAppBar>
    </header>
  );
};

export default EirHeader;
